const calculateReadingTime = (readingTime) => {
  const minutes = readingTime.getIn(['0', 'minutes']);
  const seconds = Math.ceil(readingTime.getIn(['0', 'seconds']) / 100);

  return minutes + seconds;
};

export default calculateReadingTime;
